/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Newsletter_Optin_Confirm_EmailInputs */



/**
* | output |
* | --- |
* | "Almost done - please check your inbox to confirm your subscription." |
*
* @param {Newsletter_Optin_Confirm_EmailInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const newsletter_optin_confirm_email = /** @type {((inputs?: Newsletter_Optin_Confirm_EmailInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Newsletter_Optin_Confirm_EmailInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Fast fertig - bitte bestätige die Anmeldung über die E-Mail in deinem Postfach.")
	return /** @type {LocalizedString} */ ("Almost done - please check your inbox to confirm your subscription.")
});